// Merkez tablosunun sütunları; anahtarlar ve sıra eski tabloyla aynı.
// `label`: Excel başlığı (Türkçe kalır), `id`: centers.columns.<id>.
// Durum süzgeci araç çubuğundaki Aktif / İnaktif / Tümü düğmeleridir.

export const CENTER_COLUMNS = {
  'Adı': { id: 'name', label: 'Adı', type: 'text', width: 260 },
  'SMO': { id: 'smo', label: 'SMO', type: 'text', width: 190 },
  'Yedek SMO': { id: 'smoBackup', label: 'Yedek SMO', type: 'text', width: 190 },
  'Bölge Müdürü': { id: 'regionManager', label: 'Bölge Sorumlusu', type: 'text', width: 240 },
  'Adres': { id: 'address', label: 'Adres', type: 'text', width: 260 },
  'Bilgi': { id: 'info', label: 'Bilgi', type: 'text', width: 220 },
  'Durum': { id: 'status', label: 'Durum', width: 120 },
  'İl': { id: 'city', label: 'İl', type: 'text', width: 140 },
  'İlçe': { id: 'district', label: 'İlçe', type: 'text', width: 150 },
};

export const COLUMN_KEYS = Object.keys(CENTER_COLUMNS);
export const DEFAULT_VISIBLE_COLUMNS = Object.fromEntries(COLUMN_KEYS.map((key) => [key, true]));
export const MIN_COLUMN_WIDTH = 96;
export const PINNED_COLUMNS = ['Adı'];

// Eski tabloda olduğu gibi her süzgeç yazıldığı anda uygulanır
export const getFilterState = (key, value) => (value === undefined || value === null || String(value) === '' ? 'off' : 'applied');
